import React from 'react';

export function YouTubeIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="76" height="54" viewBox="0 0 76 54" fill="none">
		<g clip-path="url(#clip0_10837_669)">
		  <path d="M74.1955 8.645C73.3172 5.39907 70.7816 2.86349 67.5357 1.98515C61.6962 0.392578 38.1937 0.392578 38.1937 0.392578C38.1937 0.392578 14.6912 0.440838 8.85177 2.03341C5.60583 2.91175 3.07025 5.44733 2.19192 8.69326C0.425607 19.0691 -0.259682 34.879 2.24017 44.8398C3.11851 48.0858 5.65409 50.6214 8.90003 51.4997C14.7395 53.0923 38.242 53.0923 38.242 53.0923C38.242 53.0923 61.7445 53.0923 67.5839 51.4997C70.8299 50.6214 73.3654 48.0858 74.2438 44.8398C76.1066 34.4495 76.6809 18.6493 74.1955 8.645Z" fill="white"/>
		  <path d="M30.7129 38.0348L50.2098 26.742L30.7129 15.4492V38.0348Z" fill="#001233"/>
		</g>
		<defs>
		  <clipPath id="clip0_10837_669">
			<rect width="75.25" height="52.9102" fill="white" transform="translate(0.606445 0.394531)"/>
		  </clipPath>
		</defs>
	  </svg>);
}